import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { GlobalConstants } from '../services/global-constants';
import { query } from '@angular/animations';
import { PermissionHandlerService } from '../services/permission-handler.service';

@Component({
  selector: 'app-training-program-view',
  templateUrl: './training-program-view.component.html',
  styleUrl: './training-program-view.component.scss'
})
export class TrainingProgramViewComponent {

  @Input() programID : any = '66bcfa58d48847a7e016506b'
  @Input() from : any 
  skelition = false
  side_view : any 
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  logStatus_set !: string 

  permissions: any;

  constructor(
    private dataService: DataService,
    // private confirmationService: ConfirmationService,
    // private messageService: MessageService,
    // private orgUnits: OrgUnitsService,
    private permissionService: PermissionHandlerService,
    // private exportService: ExportService,
    private router: Router,
  ) { }



  userId : any

  ngOnInit() {


    this.userId = localStorage.getItem('uid')

    this.getTrainingPrograms() 
    Promise.all([
      
    ]).then(e => { });
  }



  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag)
  }

  isUserCompleted(course:any){
    return course.trainingId.attendees.includes((e:any)=> e._id == this.userId)
  }

  isUserAttendee(course:any){
    return course.trainingId.attendees.some((e:any)=> e._id == this.userId)
  }

  async getTrainingPrograms() {
    try {
      
      // to give permissions of all ous

      // if(!query.ous){
      //   let newOuArray  = this.flattenTree(this.selectedTreeData)
      //   query.ous =  newOuArray 
      // }

      let query = {
        _id : this.programID
      }

      let res = await this.dataService.postData(`training-program/get-aggrigated?size=${10}&page=${1}`, query)

      console.log("RESOURCE", res);
      if (res.error) {
        return
      }
      this.side_view = res.data.data.data[0]
   
      // this.side_view = this.side_view[0]
      
      
     

      // console.log("==> isedited ",this.data)


      // this.filteredData = this.data;
      // this.totalRecords = res.data.data.totalRecords


      // this.contentstats_data_types = res.data[0].data_type;
      // this.contentstats_types = res.data[0].stats_type
      // this.page = 1;
      // this.rows = 10;
      this.skelition = false
    } catch (error) {
      console.log(error)
    }
  }



  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }


  navigateToTrainingPage(trainingId:string,params: any) {
    const url = this.router.createUrlTree(['/training/training-page', trainingId], { queryParams: params }).toString();

    if(this.from == 'user-profile'){
      this.router.navigateByUrl(url)
    }
    else window.open(url);
  }

  openCourse(course:any, flag:string){
    course ? this.navigateToTrainingPage(course, {from: this.from == 'user-profile' ? 'User' : 'SBC' }) : null
  }



}
